import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { resolveEvent } from '../../utils/worldFormat';
import type { WorldData } from '../../types/world';

/** Evento o invasión. Solo es un enlace si la equivalencia con la ficha está comprobada. */
export function EventChip({
  w,
  eventId
}: {
  w: WorldData;
  eventId: string;
}) {
  const ev = resolveEvent(w, eventId);
  if (ev.linked && ev.path) {
    return <Link to={ev.path} className="group inline-flex items-center gap-1.5 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-3 py-1.5 text-sm font-semibold text-[#F3E5AB] transition-colors duration-150 hover:bg-[#D4AF37]/20" data-id="element-1186" data-mp="29dp5p7ls3lpb">
        {ev.label}
        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1187" data-mp="2n5lsqx8lb5eu" />
      </Link>;
  }
  return <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-sm text-gray-300" title="Sin ficha enlazada" data-id="element-1188" data-mp="2s2m2bi4neqap">
      {ev.label}
      {ev.isInvasion && <span className="text-xs text-gray-500" data-id="element-1189" data-mp="epufespu4r1d">· sin ficha aprobada</span>}
    </span>;
}